import {HttpClient} from "@angular/common/http";
import {Component, OnInit, QueryList, ViewChildren, ViewChild, OnDestroy} from "@angular/core";
import {DataTableDirective} from "angular-datatables";
import {CorrectiveActionAlmahaHistoryModalComponent} from "../../corrective-action-almaha-history-modal/corrective-action-almaha-history-modal.component";
import {ReportEmailForwardComponent} from "../../report-email-forward/report-email-forward.component";
import {ReportRirPrintPreviewComponent} from "../../report-rir-print-preview/report-rir-print-preview.component";
import {DmsAccessService} from "../../services/dms-access.service";
import {DownloadService} from "../../services/download.service";
import {LocationService} from "../../services/location.service";
import {RilrService} from "../../services/rilr.service";
import {ActivatedRoute} from "@angular/router";
import {Subject} from "rxjs/Subject";
import {IOption} from "ng-select";
import {HelperService} from "../../services/helper.service";
import {SegmentService} from "../../services/segment.service";
import {TosterMessageService} from "../../services/toster-message.service";
import {AuthenticationService} from "../../services/authentication.service";
import {IncidentTypeService} from "../../services/incident-type.service";
import {BsModalRef} from "ngx-bootstrap/modal/bs-modal-ref.service";
import {BsModalService} from "ngx-bootstrap/modal";
import {NgxSpinnerService} from "ngx-spinner";
import {CorrectiveActionHistoryModalComponent} from "../../corrective-action-history-modal/corrective-action-history-modal.component";
import {CustomColumnService} from "app/services/custom-column.service";
import {CorrectiveActionModalComponent} from '../../corrective-action-modal/corrective-action-modal.component';

@Component({
  selector: "app-my-action-management",
  templateUrl: "./my-action-management.component.html",
  styleUrls: ["./my-action-management.component.scss"],
  providers: [CustomColumnService, RilrService, IncidentTypeService, TosterMessageService, HelperService, DownloadService, SegmentService, LocationService, DmsAccessService],
})
export class MyActionManagementComponent implements OnInit, OnDestroy {

  public company: Array<IOption> = [];
  public priorityArr: Array<IOption> = [];
  public documentArr: Array<IOption> = [];
  public countriesArr: Array<IOption> = [];
  public employeeOption: Array<IOption> = [];
  public regionArr: Array<IOption> = [];
  public actionAreaSelectionArr: Array<IOption> = [];
  public serviceLineArr: Array<IOption> = [];
  public departmentArr: Array<IOption> = [];
  public locationArr: Array<IOption> = [];
  public yearsArr: Array<IOption> = [];
  public monthArr: Array<IOption> = [];
  public allActionLocationArr: Array<IOption> = [];
  public enablePolicyBaseAction: boolean = false;
  public isFilterEnabled: boolean;
  public isFilterCreatedByMeAction: boolean;
  public isFilterEnabledAllAction: boolean;
  public companySystemID: number = +this.helperService.getSelectedCompanyId();
  public bsValue = new Date();
  toolTipHtml: string;
  public companyData: any = {};
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChildren(DataTableDirective)
  dtElement: QueryList<DataTableDirective>;
  totalRec: Number;
  userType: Number;
  finalIndex: any;
  orderCondition: any;
  customizedColumns: any = this.helperService.setDefaultColumnObject(['document', 'action_id', 'report_id', 'action_title', 'created_date', 'target_date', 'status', 'action']);
  customizedColumnsCreatedByMe: any = this.helperService.setDefaultColumnObject(['document', 'action_id', 'report_id', 'action_title', 'created_date', 'target_date', 'status', 'action']);
  customizedColumnsForApproval: any = this.helperService.setDefaultColumnObject(['document', 'action_id', 'report_id', 'country', 'action_title', 'person_responsible', 'created_by', 'created_date', 'target_date', 'status', 'action']);
  tableID: any;
  tableIdApproved: any;
  coloumnRefresh: boolean = true;
  public actionOverDue: number = 0;
  public masterData: any = {};
  userAccess: any;
  public htmlConfidentialMessage: string = "";
  selectedCorrectiveAction: any;
  bsModalRefCorrectiveActionHistory: BsModalRef;
  public bsModalRefCorrectiveAction: BsModalRef;
  public actionEmailID: number = 0;

  @ViewChild('swalDeleteCorrectiveAction') swalDeleteCorrectiveAction: any;
  @ViewChild('swalModalConfidentialAccess') swalModalConfidentialAccess: any;

  notAccessAlertOpen() {
    //this.notAccessSwal.showModal();
  }

  allActionsTab: boolean = false;

  reports: any[];
  createdByMeReports: any[];
  allActionReports: any[];
  filters: any = {};
  filtersByMeAction: any = {};
  filtersAllAction: any = {};
  selectedItem: any;
  message: string = "";
  documentSystemID: Number = 1;

  statusArr: any = [
    {value: 0, label: 'Open'},
    {value: 2, label: 'Closed'}
  ];
  public correctiveActionDetail: any = {};

  constructor(private tosterMessageService: TosterMessageService,
              private rilrService: RilrService,
              private incidentTypeService: IncidentTypeService,
              private route: ActivatedRoute,
              private segmentService: SegmentService,
              private http: HttpClient,
              private spinner: NgxSpinnerService,
              private downloadService: DownloadService,
              private dmsAccessService: DmsAccessService,
              private locationService: LocationService,
              private authenticationService: AuthenticationService,
              private modalService: BsModalService,
              private helperService: HelperService,
              private customColumnService: CustomColumnService) {
    this.documentSystemID = this.helperService.getRouteDataByKey(this.route.snapshot, 'documentSystemID');
    this.route.params.subscribe(params => {
      this.actionEmailID = +params['id'];
      if (this.actionEmailID != 0) {
        setTimeout(() => {
          this.viewActionTracker(this.actionEmailID);
        }, 0);
      }
    });
  }

  public ngOnDestroy() {
    if (this.bsModalRefCorrectiveActionHistory) {
      this.bsModalRefCorrectiveActionHistory.hide();
    }
    this.processSegment(this.companySystemID);
  }

  ngOnInit() { 
    const that = this;
    //that.spinner.show();
    that.getFormData();
    that.processSegment(that.companySystemID);
    that.userAccess = that.authenticationService.getUserGroupAccessRights(that.route.snapshot);
    /*    const v = localStorage.getItem('DataTables_filter');
        if (v && v != null) {
          const DataTables_filter = JSON.parse(sessionStorage.getItem('DataTables_filter'));
          that.filters.documentSystemID = that.helperService.setSelectedValue(DataTables_filter.documentSystemID);
          that.isFilterEnabled = DataTables_filter.isFilterEnabled;
        }*/
    if (sessionStorage.getItem('DataTables_filter_my_action') !== null) {
      const DataTables_filter = JSON.parse(sessionStorage.getItem('DataTables_filter_my_action'));
      if (DataTables_filter.countryID !== null) {
        this.processLocation(DataTables_filter.countryID);
      }
    }
    if (sessionStorage.getItem('dataTables_filter_all_action') !== null) {
      const dataTables_filter_all = JSON.parse(sessionStorage.getItem('dataTables_filter_all_action'));
      if (dataTables_filter_all.countryID !== null) {
        this.processLocation(dataTables_filter_all.countryID);
      }
    }
    if (sessionStorage.getItem('dataTables_filter_created_by_me_action') !== null) {
      const dataTables_filter_me = JSON.parse(sessionStorage.getItem('dataTables_filter_created_by_me_action'));
      if (dataTables_filter_me.countryID !== null) {
        this.processLocation(dataTables_filter_me.countryID);
      }
    }
    if (sessionStorage.getItem('DataTables_filter_my_action') !== null) {
      const DataTables_filter = JSON.parse(sessionStorage.getItem('DataTables_filter_my_action'));
      this.filters.documentSystemID = this.helperService.setSelectedValue(DataTables_filter.documentSystemID);
      this.filters.serviceLineSystemID = this.helperService.setSelectedValue(DataTables_filter.serviceLineSystemID);
      this.filters.countryID = this.helperService.setSelectedValue(DataTables_filter.countryID);
      this.filters.locationID = this.helperService.setSelectedValue(DataTables_filter.locationID);
      this.filters.priorityID = this.helperService.setSelectedValue(DataTables_filter.priorityID);
      this.filters.submitted = this.helperService.setSelectedValue(DataTables_filter.submitted);
      this.filters.year = this.helperService.setSelectedValue(DataTables_filter.year);
      this.filters.month = this.helperService.setSelectedValue(DataTables_filter.month);
      this.isFilterEnabled = DataTables_filter.isFilterEnabled;
    }
    if (sessionStorage.getItem('dataTables_filter_created_by_me_action') !== null) {
      const dataTables_filter_me = JSON.parse(sessionStorage.getItem('dataTables_filter_created_by_me_action'));
      this.filtersByMeAction.documentSystemID = this.helperService.setSelectedValue(dataTables_filter_me.documentSystemID);
      this.filtersByMeAction.serviceLineSystemID = this.helperService.setSelectedValue(dataTables_filter_me.serviceLineSystemID);
      this.filtersByMeAction.countryID = this.helperService.setSelectedValue(dataTables_filter_me.countryID);
      this.filtersByMeAction.locationID = this.helperService.setSelectedValue(dataTables_filter_me.locationID);
      this.filtersByMeAction.priorityID = this.helperService.setSelectedValue(dataTables_filter_me.priorityID);
      this.filtersByMeAction.submitted = this.helperService.setSelectedValue(dataTables_filter_me.submitted);
      this.filtersByMeAction.year = this.helperService.setSelectedValue(dataTables_filter_me.year);
      this.filtersByMeAction.month = this.helperService.setSelectedValue(dataTables_filter_me.month);
      this.isFilterCreatedByMeAction = dataTables_filter_me.isFilterCreatedByMeAction;
    }
    if (sessionStorage.getItem('dataTables_filter_all_action') !== null) {
      const dataTables_filter_all = JSON.parse(sessionStorage.getItem('dataTables_filter_all_action'));
      this.filtersAllAction.documentSystemID = this.helperService.setSelectedValue(dataTables_filter_all.documentSystemID);
      this.filtersAllAction.serviceLineSystemID = this.helperService.setSelectedValue(dataTables_filter_all.serviceLineSystemID);
      this.filtersAllAction.countryID = this.helperService.setSelectedValue(dataTables_filter_all.countryID);
      this.filtersAllAction.locationID = this.helperService.setSelectedValue(dataTables_filter_all.locationID);
      this.filtersAllAction.priorityID = this.helperService.setSelectedValue(dataTables_filter_all.priorityID);
      this.filtersAllAction.userSystemID = this.helperService.setSelectedValue(dataTables_filter_all.userSystemID);
      this.filtersAllAction.departmentID = this.helperService.setSelectedValue(dataTables_filter_all.departmentID);
      this.filtersAllAction.submitted = this.helperService.setSelectedValue(dataTables_filter_all.submitted);
      this.filtersAllAction.year = this.helperService.setSelectedValue(dataTables_filter_all.year);
      this.filtersAllAction.month = this.helperService.setSelectedValue(dataTables_filter_all.month);
      this.isFilterEnabledAllAction = dataTables_filter_all.isFilterEnabledAllAction;
    }
    that.dtOptions[0] = {
      order: [[0, "desc"]],
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [5, 10, 15, 50, 100],
      serverSide: true,
      processing: true,
      stateSave: true,
      stateDuration: -1,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.companySystemID = that.companySystemID;
        if (that.isFilterEnabled) {
          dataTablesParameters.documentSystemID = this.filters.documentSystemID;
          dataTablesParameters.serviceLineSystemID = this.filters.serviceLineSystemID;
          dataTablesParameters.countryID = this.filters.countryID;
          dataTablesParameters.locationID = this.filters.locationID;
          dataTablesParameters.priorityID = this.filters.priorityID;
          dataTablesParameters.submitted = this.filters.submitted;
          dataTablesParameters.year = this.filters.year;
          dataTablesParameters.month = this.filters.month;
        }
        that.rilrService
          .getAllMyAssignedCorrectiveActions()
          .post(dataTablesParameters)
          .subscribe(resp => {
            that.reports = resp.data.data;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: []
            });
            that.totalRec = resp.data.recordsTotal;
            that.orderCondition = resp.data.orderCondition;
            that.spinner.hide();
            that.customizedColumns = resp.data.customizedColumns;
            that.tableID = resp.data.tableId;
            this.coloumnRefresh = false;
            setTimeout(() => {
              this.coloumnRefresh = true;
            }, 0);
          }, (error) => {
            that.spinner.hide();
          });
      },
      columns: [
        {data: 'DT_Row_Index', name: 'DT_Row_Index'}
      ],
      responsive: true
    };

    that.dtOptions[1] = {
      order: [[0, "desc"]],
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [5, 10, 15, 50, 100],
      serverSide: true,
      processing: true,
      stateSave: true,
      stateDuration: -1,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.companySystemID = that.companySystemID;
        if (that.isFilterCreatedByMeAction) {
          dataTablesParameters.documentSystemID = this.filtersByMeAction.documentSystemID;
          dataTablesParameters.serviceLineSystemID = this.filtersByMeAction.serviceLineSystemID;
          dataTablesParameters.countryID = this.filtersByMeAction.countryID;
          dataTablesParameters.locationID = this.filtersByMeAction.locationID;
          dataTablesParameters.priorityID = this.filtersByMeAction.priorityID;
          dataTablesParameters.submitted = this.filtersByMeAction.submitted;
          dataTablesParameters.year = this.filtersByMeAction.year;
          dataTablesParameters.month = this.filtersByMeAction.month;
        }
        that.rilrService
          .getAllCreatedByMeCorrectiveActions()
          .post(dataTablesParameters)
          .subscribe(resp => {
            that.createdByMeReports = resp.data.data;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: []
            });
            that.totalRec = resp.data.recordsTotal;
            that.orderCondition = resp.data.orderCondition;
            that.spinner.hide();
            that.customizedColumnsCreatedByMe = resp.data.customizedColumns;
            that.tableID = resp.data.tableId;
            this.coloumnRefresh = false;
            setTimeout(() => {
              this.coloumnRefresh = true;
            }, 0);
          }, (error) => {
            that.spinner.hide();
          });
      },
      columns: [
        {data: 'DT_Row_Index', name: 'DT_Row_Index'}
      ],
      responsive: true
    };

    that.dtOptions[2] = {
      order: [[0, "desc"]],
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [5, 10, 15, 50, 100],
      serverSide: true,
      processing: true,
      stateSave: true,
      stateDuration: -1,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.companySystemID = that.companySystemID;
        if (that.isFilterEnabledAllAction) {
          dataTablesParameters.documentSystemID = this.filtersAllAction.documentSystemID;
          dataTablesParameters.serviceLineSystemID = this.filtersAllAction.serviceLineSystemID;
          dataTablesParameters.countryID = this.filtersAllAction.countryID;
          dataTablesParameters.locationID = this.filtersAllAction.locationID;
          dataTablesParameters.priorityID = this.filtersAllAction.priorityID;
          dataTablesParameters.userSystemID = this.filtersAllAction.userSystemID;
          dataTablesParameters.departmentID = this.filtersAllAction.departmentID;
          dataTablesParameters.submitted = this.filtersAllAction.submitted;
          dataTablesParameters.year = this.filtersAllAction.year;
          dataTablesParameters.month = this.filtersAllAction.month;
        }
        that.rilrService
          .getAllAssignedCorrectiveActionsLPT()
          .post(dataTablesParameters)
          .subscribe(resp => {
            that.allActionReports = resp.data.data;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: []
            });
            that.totalRec = resp.data.recordsTotal;
            that.orderCondition = resp.data.orderCondition;
            that.customizedColumnsForApproval = resp.data.customizedColumns;
            that.tableIdApproved = resp.data.tableId;
            that.coloumnRefresh = false;
            setTimeout(() => {
              that.coloumnRefresh = true;
            }, 0);
            that.spinner.hide();
          }, (error) => {
            that.spinner.hide();
          });
      },
      columns: [
        {data: 'DT_Row_Index', name: 'DT_Row_Index'}
      ],
      responsive: true
    };

    that.modalService.onHide.subscribe((reason: string, event) => {
      if (reason) {
        if (reason === 'corrective_action_edit_closed') {
          that.filterApply();
          that.filterApply2();
          that.filterApply3();
        }
        if (reason === 'corrective_action_success') {
          that.filterApply3();
        }
      }
    });

  }

  public getFormData() {
    const that = this;
    that.incidentTypeService
      .getIncidentFormData()
      .get({
        companyId: that.companySystemID,
        isReport: 1,
      })
      .subscribe(data => {
        let resp = data.data.data;
        that.documentArr = that.helperService.setSelect2DropDownOptionsConcatLabel(resp.document, 'documentSystemID', 'documentID', 'documentDescription');
        that.priorityArr = that.helperService.setSelect2DropDownOptions(resp.priority, 'priorityID', 'description');
        that.departmentArr = that.helperService.setSelect2DropDownOptions(resp.department, 'departmentID', 'description');
        that.countriesArr = that.helperService.setSelect2DropDownOptions(resp.country, "countryID", "countryName");
        that.regionArr = that.helperService.setSelect2DropDownOptions(resp.region, "id", "regionName");
        that.yearsArr = that.helperService.setSelect2DropDownOptions(resp.years, 'value', 'label');
        that.monthArr = that.helperService.setSelect2DropDownOptions(resp.months, 'value', 'label');
        that.userType = resp.userType;
        that.companyData = resp.company;
        if (that.companyData.policyBaseCActionAdd == 1) {
          that.enablePolicyBaseAction = true;
        }
        if (that.userType == 2) {
          that.allActionsTab = true;
        }
      }, (error) => {
      });
  }

  /*filter apply*/
  filterApply(): void {
    var i = 1;
    this.dtElement.forEach((dtElement: DataTableDirective) => {
      if (i === 1) {
        const filter = {
          'documentSystemID': this.filters.documentSystemID,
          'serviceLineSystemID': this.filters.serviceLineSystemID,
          'countryID': this.filters.countryID,
          'locationID': this.filters.locationID,
          'priorityID': this.filters.priorityID,
          'submitted': this.filters.submitted,
          'year': this.filters.year,
          'month': this.filters.month,
          'isFilterEnabled': this.isFilterEnabled,
        };
        sessionStorage.setItem('DataTables_filter_my_action', JSON.stringify(filter));
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      }
      i++;
    });
  }

  filterApply2(): void {
    var i = 1;
    this.dtElement.forEach((dtElement: DataTableDirective) => {
      if (i === 3) {
        const filter = {
          'documentSystemID': this.filtersAllAction.documentSystemID,
          'serviceLineSystemID': this.filtersAllAction.serviceLineSystemID,
          'countryID': this.filtersAllAction.countryID,
          'locationID': this.filtersAllAction.locationID,
          'priorityID': this.filtersAllAction.priorityID,
          'userSystemID': this.filtersAllAction.userSystemID,
          'departmentID': this.filtersAllAction.departmentID,
          'submitted': this.filtersAllAction.submitted,
          'year': this.filtersAllAction.year,
          'month': this.filtersAllAction.month,
          'isFilterEnabledAllAction': this.isFilterEnabledAllAction,
        };
        sessionStorage.setItem('dataTables_filter_all_action', JSON.stringify(filter));
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      }
      i++;
    });
  }

  filterApply3(): void {
    var i = 1;
    this.dtElement.forEach((dtElement: DataTableDirective) => {
      if (i === 2) {
        const filter = {
          'documentSystemID': this.filtersByMeAction.documentSystemID,
          'serviceLineSystemID': this.filtersByMeAction.serviceLineSystemID,
          'countryID': this.filtersByMeAction.countryID,
          'locationID': this.filtersByMeAction.locationID,
          'priorityID': this.filtersByMeAction.priorityID,
          'userSystemID': this.filtersByMeAction.userSystemID,
          'departmentID': this.filtersByMeAction.departmentID,
          'submitted': this.filtersByMeAction.submitted,
          'year': this.filtersByMeAction.year,
          'month': this.filtersByMeAction.month,
          'isFilterCreatedByMeAction': this.isFilterCreatedByMeAction,
        };
        sessionStorage.setItem('dataTables_filter_created_by_me_action', JSON.stringify(filter));
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      }
      i++;
    });
  }

  employeeDeselect() {
    this.employeeOption = [];
    this.filterApply2();
  }

  indexOrder(value) {
    return this.helperService.indexOrder(value, this.orderCondition, this.totalRec);
  }

  mouseEnterToolTip(data) {
    this.toolTipHtml = data;
  }

  mouseLeaveToolTip() {
    this.toolTipHtml = "";
  }

  filterEnable() {
    this.isFilterEnabled = !this.isFilterEnabled;
    if (!this.isFilterEnabled) {
      this.filters = {};
      this.filterApply();
    }
  }

  filterEnableCreatedByMe() {
    this.isFilterCreatedByMeAction = !this.isFilterCreatedByMeAction;
    if (!this.isFilterCreatedByMeAction) {
      this.filtersByMeAction = {};
      this.filterApply3();
    }
  }

  filterEnableAllAction() {
    this.isFilterEnabledAllAction = !this.isFilterEnabledAllAction;
    if (!this.isFilterEnabledAllAction) {
      this.filtersAllAction = {};
      this.filterApply2();
    }
  }

  public typehead(value: any): void {
    const that = this;
    if (value.length > 2) {
      that.getEmployees(value);
    } else {
      that.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.incidentTypeService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': this.companySystemID
      })
      .subscribe(resp => {
        var tempOption = resp.data.data;
        that.employeeOption = [];
        that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, 'employeeSystemID', 'empName', 'countryName', 'description');
      }, (err) => {
        that.employeeOption = [];
      });
  }

  public edit(reportdata) {
    const that = this;
    that.spinner.show();
    /*
    if (reportdata.documentSystemID == 1) {
      that.helperService.go("create-new-entry/incident-edit-alkhorayef/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 2) {
      that.helperService.go("audit-management/audit-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 3) {
      that.helperService.go("meetings/meeting-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 4) {
      that.helperService.go("audit-management/management-visit-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 6) {
      that.helperService.go("audit-management/self-assessment-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 7) {
      that.helperService.go("create-new-entry/observation-edit-alkhorayef/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 8) {
      that.getConfidentialReportAccess(reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 10) {
      that.helperService.go("management-of-change/management-of-change-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 11) {
      that.helperService.go("audit-management/non-conformance-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 12) {
      that.helperService.go("create-new-entry/emergency-response-drill-edit-alkhorayef/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 14) {
      that.helperService.go("create-new-entry/permit-to-work-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 15) {
      that.helperService.go("audit-management/inspection-edit-almaha/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 18) {
      that.helperService.go("management-of-change/management-of-change-production-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 19) {
      that.helperService.go("management-of-change/management-of-change-technical-edit/" + reportdata.reportSystemID);
    } else if (reportdata.documentSystemID == 22) {
      that.helperService.go("management-of-change/exemption-edit/" + reportdata.reportSystemID);
    }
    */
    that.spinner.hide();
    
       this.modalService.onHide.subscribe((reason: string, event) => {
      console.log('hide');
      
    });
    
  }

  public viewActionTracker(actionID) {
    const that = this;
    that.spinner.show();
    that.rilrService
      .reportCorrectiveActionsHistory()
      .get({actionID: actionID})
      .subscribe(data => {
        let resp = data.data.data;

        that.actionAreaSelectionArr = that.helperService.setSelect2DropDownOptions(resp.actionarea, 'id', 'description');
        that.bsModalRefCorrectiveActionHistory = that.modalService.show(CorrectiveActionHistoryModalComponent, {
          class: "modal-xlg",
          backdrop: "static",
        });
        that.bsModalRefCorrectiveActionHistory.content.masterData = resp;
        that.bsModalRefCorrectiveActionHistory.content.priorityArr = that.priorityArr;
        that.bsModalRefCorrectiveActionHistory.content.documentArr = that.documentArr;
        that.bsModalRefCorrectiveActionHistory.content.actionAreaSelectionArr = that.actionAreaSelectionArr;
        that.bsModalRefCorrectiveActionHistory.content.actionID = actionID;
        that.bsModalRefCorrectiveActionHistory.content.policyBaseAction = that.companyData.policyBaseCActionAdd;
        that.bsModalRefCorrectiveActionHistory.content.myActionBase = 1;
        that.bsModalRefCorrectiveActionHistory.content.masterData.priorityID = that.helperService.setSelectedValue(resp.priorityID);
        that.bsModalRefCorrectiveActionHistory.content.masterData.submitted = that.helperService.setSelectedValue(resp.submitted);
        that.bsModalRefCorrectiveActionHistory.content.masterData.personResEmpSystemID = that.helperService.setSelectedValue(resp.personResEmpSystemID);
        that.bsModalRefCorrectiveActionHistory.content.masterData.actionArea = that.helperService.setSelectedValue(resp.actionArea);
        that.bsModalRefCorrectiveActionHistory.content.masterData.documentSystemID = that.helperService.setSelectedValue(resp.documentSystemID);
        that.bsModalRefCorrectiveActionHistory.content.masterData.reportSystemID = that.helperService.setSelectedValue(resp.reportSystemID);
      
     
      }, (error) => {
      });
  }

  public exportToCSV() {
    const that = this;
    that.spinner.show();
    that.filtersAllAction.companySystemID = that.companySystemID;
    const headersConfig = that.downloadService.createAuthHeader();
    const filename: string = 'api/v1/exportAllActions';
    that.http.post(filename, that.filtersAllAction,
      {
        headers: headersConfig
      }
    ).subscribe(data => {
      that.spinner.hide();
    }, (error) => {
      that.spinner.hide();
      if (error.status == 200) {
        let dt = Date.now();
        that.dmsAccessService.downloadFile2(error.error.text, 'text/csv', 'report_' + dt + '.csv');
      } else {
        that.tosterMessageService.showError('Error', 'Unable to export report csv');
      }
    });
  }

  public removeCorrectiveActionConfirm(action) {
    this.selectedCorrectiveAction = action;
    this.swalDeleteCorrectiveAction.show();
  }

  public removeCorrectiveAction() {
    let that = this;
    that.rilrService
      .reportCorrectiveActionsUD(that.selectedCorrectiveAction.actionID)
      .remove()
      .subscribe(resp => {
        that.tosterMessageService.showSuccess("Success", "Successfully deleted the corrective action");
        that.filterApply2();
      }, (error) => {
        that.tosterMessageService.showError("Error", error.data.message);
      });
  }

  public cancelDelete() {

  }

  public processSegment(companySystemID) {
    const that = this;
    that.serviceLineArr = [];
    that.segmentService
      .getSegmentByCompany()
      .get({
        companySystemID: companySystemID,
      })
      .subscribe((data) => {
        var resp = data.data.data;
        that.serviceLineArr = that.helperService.setSelect2DropDownOptionsConcatLabel(resp, 'id', 'segment_code', 'segment_description');
      }, () => {
      });
  }

  public processLocation(data) {
    const that = this;
    that.locationArr = [];
    that.locationService
      .getLocationsByCountry()
      .get({
        countryCode: data, companySystemID: that.companySystemID,
      })
      .subscribe((data) => {
        var resp = data.data.data;
        that.locationArr = that.helperService.setSelect2DropDownOptions(resp, 'autoID', 'description');
      }, () => {
      });
  }

  public unSelectCountry() {
    this.locationArr = [];
  }

  public processLocationAllAction(data) {
    const that = this;
    that.allActionLocationArr = [];
    that.locationService
      .getLocationsByCountry()
      .get({
        countryCode: data.value, companySystemID: that.companySystemID,
      })
      .subscribe((data) => {
        var resp = data.data.data;
        that.allActionLocationArr = that.helperService.setSelect2DropDownOptions(resp, 'autoID', 'description');
      }, () => {
      });
  }

  public unSelectCountryAll() {
    this.allActionLocationArr = [];
  }

  setDefaultColumn(event) {
    this.coloumnRefresh = false;
    this.customizedColumns = event;
    setTimeout(() => {
      this.coloumnRefresh = true;
    }, 0);
    this.filterApply();
  }

  setDefaultColumnForApproval(event) {
    this.coloumnRefresh = false;
    this.customizedColumnsForApproval = event;
    setTimeout(() => {
      this.coloumnRefresh = true;
    }, 0);
    this.filterApply();
  }

  public showConfidentialHtml() {
    setTimeout(() => {
      this.swalModalConfidentialAccess.show();
    }, 0);
  }

  public getConfidentialReportAccess(reportSystemID) {
    const that = this;
    that.rilrService
      .checkConfidentialReportAccess()
      .get({
        reportSystemID: reportSystemID,
      })
      .subscribe(resp => {
        const access = resp.data.data.access;
        if (access == 'no_access') {
          that.htmlConfidentialMessage = 'Confidential Report : You dont have permission to access this report';
          that.showConfidentialHtml();
        } else {
          that.helperService.go('create-new-entry/accident-report-edit-alkhorayef/' + reportSystemID);
        }
      }, (err) => {
      });
  }

  public createCorrectiveAction() {
    this.correctiveActionDetail = {};
    this.bsModalRefCorrectiveAction = this.modalService.show(CorrectiveActionModalComponent, {
      class: 'modal-lg',
      keyboard: false,
      backdrop: 'static'
    });
    this.bsModalRefCorrectiveAction.content.isEdit = 0;
    this.bsModalRefCorrectiveAction.content.reportID = 0;
    this.bsModalRefCorrectiveAction.content.documentSystemID = 0;
    this.bsModalRefCorrectiveAction.content.policyBaseAction = 1;
    this.bsModalRefCorrectiveAction.content.myActionBase = 1;
    this.bsModalRefCorrectiveAction.content.masterData = this.correctiveActionDetail;
    this.bsModalRefCorrectiveAction.content.masterData.targetDate = this.bsValue;
    this.bsModalRefCorrectiveAction.content.priorityArr = this.priorityArr;
    this.bsModalRefCorrectiveAction.content.masterData.submitted = this.helperService.setSelectedValue(0);
  }
}



// WEBPACK FOOTER //
// /app/src/app/my-action-items/my-action-management/my-action-management.component.ts